module.exports = __webpack_public_path__ + "static/media/GIB.1aa33116.png";